import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
import './Contribution.css';

const {Text, Paragraph} = Typography;
const Content = Layout;
const General = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className='Title2' style={{color: appColors['ColorNa'], fontSize: '8vh'}}>Contributions/Biobricks</Paragraph>
        <Paragraph className= 'Title3' style={{color: appColors['ColorX'], marginTop: '-7vh'}}>General description</Paragraph>
        <Text className='BaseText2'>For our project we design a biosensor that could detect four different biomarkers in a blood sample: Tumor Necrosis Factor-α (TNF-α), Chemokine (C-X-C motif) ligand 9 (CXCL9), Interleukin 10 (IL-10) and C-Reactive Protein (CRP), with the use of aptamers.<br/><br/>In the design of our proof of concept we decided to use only one protein in order to standardize the protocols and in the future test the other three biomarkers. For this, we chose CRP as it is the most characterized protein from the four biomarkers and it was more accessible to us for working with it. Therefore, in the Registry we only published the aptamers for CRP, as they were the ones that we could start characterizing. Nevertheless, here we present the rest of the sequences of the other aptamers we would use to detect the other biomarkers in our project.</Text>
        <Text className='BaseText' style={{textAlign: 'center', marginTop: '3%'}}>Table 1. BioBricks for iMoAge published in the Registry.</Text>
        <table className="customTable">
          <thead>
            <tr>
              <th><Text className='BaseText'>Code</Text></th>
              <th><Text className='BaseText'>Type</Text></th>
              <th><Text className='BaseText'>Short description</Text></th>
              <th><Text className='BaseText'>Length</Text></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><Text className='BaseText' style={{fontSize: '2vh'}}><a target="_blank" rel="noopener noreferrer" href='http://parts.igem.org/Part:BBa_K4464000'>BBa_K4464000</a></Text></td>
              <td><Text className='BaseText' style={{fontSize: '2vh'}}>Primary</Text></td>
              <td><Text className='BaseText' style={{fontSize: '2vh'}}>It is a recognition aptamer that binds to C-Reactive Protein and can have modifications preferably in the 3’ end.</Text></td>
              <td><Text className='BaseText' style={{fontSize: '2vh'}}>72 bp</Text></td>
            </tr>
            <tr>
              <td><Text className='BaseText' style={{fontSize: '2vh'}}><a target="_blank" rel="noopener noreferrer" href='http://parts.igem.org/Part:BBa_K4464001'>BBa_K4464001</a></Text></td>
              <td><Text className='BaseText' style={{fontSize: '2vh'}}>Secondary</Text></td>
              <td><Text className='BaseText' style={{fontSize: '2vh'}}>It is a recognition aptamer that binds to C-Reactive Protein and can have modifications preferably in the 3’ end.</Text></td>
              <td><Text className='BaseText' style={{fontSize: '2vh'}}>72 bp</Text></td>
            </tr>
          </tbody>
        </table>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default General;
